<ng-container *ngIf="logoImage">
    <img [src]="logoPath" alt="logo" style="max-width: 25vw;max-height: 50vh;">
</ng-container>

<ng-container *ngIf="logoHtml">
    <div [innerHtml]="innerHtml"></div>
</ng-container>